import React from 'react';

interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

export function Radio({ label, className = '', disabled, ...props }: RadioProps) {
  return (
    <label className={`flex items-center gap-3 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
      {/* Hidden native input for accessibility + keyboard */}
      <div className="relative flex shrink-0 items-center justify-center">
        <input
          type="radio"
          disabled={disabled}
          {...props}
          className={`sr-only peer ${className}`}
        />
        {/* Outer ring */}
        <div className="h-4 w-4 rounded-full border-2 border-border transition-colors peer-checked:border-primary peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-background" />
        {/* Inner dot */}
        <div className="absolute h-2 w-2 rounded-full bg-transparent transition-colors peer-checked:bg-primary" />
      </div>
      <span className="text-sm text-muted-foreground select-none">{label}</span>
    </label>
  );
}
